'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentThread = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reselect = require('reselect');

var _getCurrentChannel = require('../../selectors/conversationSelectors/getCurrentChannel');

var _getThreads = require('./getThreads');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCurrentThread = exports.getCurrentThread = (0, _reselect.createSelector)([_getThreads.getThreads, _getCurrentChannel.getCurrentChannel], function (threads, channel) {
  return (0, _getIn2.default)([channel], threads);
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/getCurrentThread.js
// module id = 326
// module chunks = 2 3